import { AI_APPLY_COPY } from "@/lib/ai-apply"

export const strings = {
  ar: {
    tagline: "دليل محدث لـ ١٦٠+ شركة سعودية تبني مستقبل التقنية والذكاء الاصطناعي",
    heroHeadline: "دور على وظايف في ١٦٠+ شركة سعودية ناشئة ممولة",
    heroCta: "تصفح ١٦٠+ وظيفة في الشركات الناشئة",
    skipToContent: "تخطي إلى المحتوى الرئيسي",
    searchLabel: "ابحث عن شركات",
    searchExample: "مثال: Humain، Tamara",
    opensInNewTab: "(يفتح في تبويب جديد)",
    clearSearch: "مسح البحث",
    madeBy: "تصميم",
    searchJobs: "تنبيهات الوظائف",
    searchPlaceholder: "ابحث عن شركات...",
    hotCompanies: "شركات مميزة",
    filters: "تصفية",
    sector: "القطاع",
    allSectors: "كل القطاعات",
    stage: "المرحلة",
    allStages: "كل المراحل",
    suggestCompany: "اقترح شركة",
    companies: "شركة",
    newestFirst: "الاحدث اولا",
    viewJobs: "صفحة الوظائف",
    noResults: "ما في نتائج",
    clearFilters: "امسح الفلاتر",
    founders: "المؤسسين",
    totalRaised: "اجمالي التمويل",
    hqCity: "المقر",
    employees: "الموظفين",
    founded: "التأسيس",
    lastRound: "اخر جولة",
    socials: "التواصل",
    suggestTitle: "اقترح شركة",
    suggestDesc: "تعرف شركة لازم نضيفها؟",
    companyName: "اسم الشركة",
    website: "الموقع",
    details: "تفاصيل",
    submit: "ارسال",
    submitting: "جاري الارسال...",
    submitted: "تم الارسال",
    searchJobsTitle: "نرسل لك عروض وظايف مخصصة كل أسبوع.",
    searchJobsDesc: "",
    jobAlertSubmit: "احصل على تنبيهات الوظائف",
    jobAlertSuccess: "تم! بنرسلك الوظائف أول ما تنزل.",
    jobAlertError: "صار خطأ. حاول مرة ثانية.",
    name: "الاسم",
    title: "المسمى الوظيفي",
    email: "الايميل",
    installAriaLabel: "أضف BuildSaudi إلى الشاشة الرئيسية",
    installTitle: "أضف BuildSaudi إلى الشاشة الرئيسية",
    installSubtitle: "وصول أسرع لوظائف الشركات الناشئة السعودية والبحث عن الشركات — مباشرة من شاشتك الرئيسية.",
    installStep1: ["اضغط زر ", "مشاركة", " في المتصفح"] as const,
    installStep2: ["مرّر واضغط ", "إضافة إلى الشاشة الرئيسية", ""] as const,
    installStep3: ["اضغط ", "إضافة", " للتأكيد"] as const,
    installFooterNote: "استخدم خيارات المشاركة أو القائمة في المتصفح لإضافة هذه الصفحة إلى شاشتك الرئيسية.",
    installNeverAgain: "لا تُظهر مرة أخرى",
    installClose: "إغلاق",
    aiApplyCta: "تقديم تلقائي بالـ AI",
    aiApplyBannerLine: "لسه تقدّم على وظايف بنفسك؟",
    aiApplyBannerOffer: "تقديم تلقائي بالـ AI — خصم ٤٠٪ للطلاب والمتخرجين",
    aiApplyBenefitLine: AI_APPLY_COPY.ar.benefit,
    aiApplySpeedLine: AI_APPLY_COPY.ar.speed,
    aiApplyUpsellTitle: "تبي تقدّم أسرع؟",
    aiApplyUpsellDesc: "أداة التقديم التلقائي بالـ AI تكتب سيرتك وتقدّم عنك على مئات الوظائف — خصم ٤٠٪ للطلاب والمتخرجين.",
    aiApplyUpsellCta: "تقديم تلقائي بالـ AI",
    aiApplyUpsellSkip: "تخطّي",
    applyAt: "قدّم في",
    back: "رجوع",
    jobsBoard: "الوظائف",
    jobsTagline: "وظائف فردية في شركات سعودية ممولة — التقديم على موقع الشركة الرسمي.",
    jobsCount: "وظيفة",
    jobsCompanies: "شركة",
    jobsSearchPlaceholder: "ابحث عن وظيفة أو شركة...",
    allFunctions: "كل التخصصات",
    allSeniority: "كل المستويات",
    allCities: "كل المدن",
    jobFunction: "التخصص",
    seniority: "المستوى",
    apply: "قدّم",
    noJobs: "ما في وظائف تطابق الفلاتر.",
    jobsUpdated: "آخر تحديث",
    jobPosted: "نُشرت",
    jobSeen: "آخر ظهور",
    browseJobs: "تصفح الوظائف",
    openRoles: "الوظائف المفتوحة",
    jobsCoverage: "نعرض الوظائف المنشورة على أنظمة التوظيف الرسمية للشركات في الدليل. التغطية جزئية وتتوسع مع كل تحديث.",
    companiesDirectory: "الدليل",
    fnEngineering: "هندسة",
    fnProduct: "منتج",
    fnDesign: "تصميم",
    fnSales: "مبيعات",
    fnMarketing: "تسويق",
    fnOperations: "عمليات",
    fnPeople: "موارد بشرية",
    fnFinance: "مالية",
    fnOther: "أخرى",
    snIntern: "تدريب",
    snEntry: "مبتدئ",
    snMid: "متوسط",
    snSenior: "خبير",
    prefsTitle: "تفضيلات الوظائف",
    prefsTagline:
      "حدّد تخصصك ومدينتك وقطاعك. نشرة الاثنين تجيب الوظائف اللي تطابق اختيارك من ١٦٠+ شركة.",
    prefsEmailHint: "استخدم نفس الايميل اللي سجّلت فيه تنبيهات الوظائف.",
    prefsLoad: "تحميل التفضيلات",
    prefsSave: "حفظ التفضيلات",
    prefsSaved: "تم الحفظ. الوظائف تحت محدّثة حسب اختيارك.",
    prefsNotFound: "هذا الايميل مو مسجّل. سجّل تنبيهات الوظائف من صفحة الوظائف أولاً.",
    prefsError: "صار خطأ. حاول مرة ثانية.",
    prefsMatching: "وظائف تطابق تفضيلاتك",
    prefsNone: "ما في وظائف تطابق الاختيار الحالي. وسّع الفلاتر أو امسحها.",
    prefsUnsub:
      "لإلغاء الاشتراك استخدم رابط إلغاء الاشتراك في رسالة النشرة. ما نغيّر طريقة الإلغاء.",
    prefsEmptyHint: "إذا تركت خانة فاضية، نعتبرها مفتوحة على كل الخيارات.",
    prefsCompanyStage: "مرحلة الشركة",
    prefsBack: "الوظائف",
    jobAlertPrefsCta: "حدّد تفضيلاتك عشان النشرة تجيب اللي يناسبك.",
  },
  en: {
    tagline: "A curated directory of 160+ companies building the future of Saudi",
    heroHeadline: "Find jobs at 160+ funded Saudi startups",
    heroCta: "Browse 160+ startup jobs",
    skipToContent: "Skip to main content",
    searchLabel: "Search companies",
    searchExample: "e.g. Humain, Tamara",
    opensInNewTab: "(opens in new tab)",
    clearSearch: "Clear search",
    madeBy: "Made by",
    searchJobs: "Get job alerts",
    searchPlaceholder: "search companies...",
    hotCompanies: "Hot Companies",
    filters: "Filters",
    sector: "Sector",
    allSectors: "All Sectors",
    stage: "Stage",
    allStages: "All Stages",
    suggestCompany: "Suggest a Company",
    companies: "companies",
    newestFirst: "Newest first",
    viewJobs: "Careers page",
    noResults: "no companies match your filters.",
    clearFilters: "clear filters",
    founders: "Founders",
    totalRaised: "Total Raised",
    hqCity: "HQ City",
    employees: "Employees",
    founded: "Founded",
    lastRound: "Last Round",
    socials: "Socials",
    suggestTitle: "Suggest a Company",
    suggestDesc: "Know a company we should add?",
    companyName: "Company Name",
    website: "Website",
    details: "Details",
    submit: "Submit Suggestion",
    submitting: "Submitting...",
    submitted: "Submitted!",
    searchJobsTitle: "We send you personalized job offers every week.",
    searchJobsDesc: "",
    jobAlertSubmit: "Get job alerts",
    jobAlertSuccess: "You're in! We'll notify you when jobs drop.",
    jobAlertError: "Something went wrong. Try again.",
    name: "Name",
    title: "Title",
    email: "Email",
    installAriaLabel: "Add BuildSaudi to your home screen",
    installTitle: "Add BuildSaudi to your home screen",
    installSubtitle: "Get faster access to Saudi startup jobs and company search — right from your home screen.",
    installStep1: ["Tap the ", "Share", " button in your browser"] as const,
    installStep2: ["Scroll and tap ", "Add to Home Screen", ""] as const,
    installStep3: ["Tap ", "Add", " to confirm"] as const,
    installFooterNote: "Use your browser's share or menu options to add this page to your home screen.",
    installNeverAgain: "Never show again",
    installClose: "Close",
    aiApplyCta: "Auto-apply with AI",
    aiApplyBannerLine: "Still applying one-by-one?",
    aiApplyBannerOffer: "Auto-apply with AI — 40% off for students & grads",
    aiApplyBenefitLine: AI_APPLY_COPY.en.benefit,
    aiApplySpeedLine: AI_APPLY_COPY.en.speed,
    aiApplyUpsellTitle: "Apply faster?",
    aiApplyUpsellDesc: "Auto-apply with AI writes your CV and submits applications for you — 40% off for students & grads.",
    aiApplyUpsellCta: "Auto-apply with AI",
    aiApplyUpsellSkip: "Skip",
    applyAt: "Apply at",
    back: "Back",
    jobsBoard: "Jobs",
    jobsTagline: "Individual openings at funded Saudi companies — apply on the employer's official page.",
    jobsCount: "jobs",
    jobsCompanies: "companies",
    jobsSearchPlaceholder: "search jobs or companies...",
    allFunctions: "All functions",
    allSeniority: "All seniority",
    allCities: "All cities",
    jobFunction: "Function",
    seniority: "Seniority",
    apply: "Apply",
    noJobs: "no jobs match your filters.",
    jobsUpdated: "Updated",
    jobPosted: "Posted",
    jobSeen: "Last seen",
    browseJobs: "Browse jobs",
    openRoles: "Open roles",
    jobsCoverage: "We list roles published on official ATS boards for companies in the directory. Coverage is partial and grows with each refresh.",
    companiesDirectory: "Directory",
    fnEngineering: "Engineering",
    fnProduct: "Product",
    fnDesign: "Design",
    fnSales: "Sales",
    fnMarketing: "Marketing",
    fnOperations: "Operations",
    fnPeople: "People",
    fnFinance: "Finance",
    fnOther: "Other",
    snIntern: "Intern",
    snEntry: "Entry",
    snMid: "Mid",
    snSenior: "Senior",
    prefsTitle: "Job preferences",
    prefsTagline:
      "Set your role, city, and sector. Monday's digest keeps the jobs that match from 160+ companies.",
    prefsEmailHint: "Use the same email you used for job alerts.",
    prefsLoad: "Load preferences",
    prefsSave: "Save preferences",
    prefsSaved: "Saved. Matching jobs below are updated.",
    prefsNotFound: "This email is not on the alert list. Sign up from the jobs page first.",
    prefsError: "Something went wrong. Try again.",
    prefsMatching: "Jobs that match your preferences",
    prefsNone: "No openings match the current filters. Widen or clear them.",
    prefsUnsub: "To unsubscribe, use the unsubscribe link in the digest email. That path is unchanged.",
    prefsEmptyHint: "An empty field means no filter on that axis.",
    prefsCompanyStage: "Company stage",
    prefsBack: "Jobs",
    jobAlertPrefsCta: "Set your preferences so the digest matches what you want.",
  },
} as const

export type Lang = "en" | "ar"
